module.exports = __webpack_public_path__ + "static/img/r-2-1.f7a22b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-2/r-2-1.png
// module id = 8NMT
// module chunks = 0